import React from 'react';

function stripToAllowed(html) {
  if (!html) return '';
  // Erlaubte Tags: <b>, <strong>, <br>, <p>, <a href="..."> – alles andere entfernen, Inhalt behalten
  // Öffnende Tags: nur b, strong, br, p und a (mit optionalen Attributen) erlaubt
  return html
    .replace(/<(?!\/?(?:b|strong|br|p|a)(?:\s[^>]*)?)([a-zA-Z][^>]*)>/gi, '')
    .replace(/<\/(?!(?:b|strong|p|a))[a-zA-Z]+>/gi, '');
}

export default function AnswerFeedbackView({ correct, explanation, source, onNext }) {
  return (
    <div className="container text-center py-5" style={{ maxWidth: '700px' }}>
      <h2 className={`mb-4 fw-bold ${correct ? 'text-success' : 'text-danger'}`}>
        {correct ? '✅ Richtig!' : '❌ Falsch'}
      </h2>

      {explanation && (
        <div
          className="fs-5 mb-4 text-start"
          dangerouslySetInnerHTML={{ __html: stripToAllowed(explanation) }}
        />
      )}

{source && (
  <div
    className="text-muted mt-4 text-start quelle small"
    dangerouslySetInnerHTML={{ __html: stripToAllowed(source) }}
  />
)}

      <button className="btn btn-primary mt-4 px-5 py-2 fs-5" onClick={onNext}>
        Weiter
      </button>
    </div>
  );
}
